import { useTranslate } from '@refinedev/core';
import { Button } from 'antd';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { useMobilePreview } from './mobilePreviewContext';

/** Flips the previewed phone between its light and dark surface. */
export const MobileThemeToggle = () => {
  const t = useTranslate();
  const { mobileTheme, setMobileTheme } = useMobilePreview();
  const label = t('base.mobile_preview.theme_toggle');

  return (
    <Button
      size="small"
      icon={mobileTheme === 'light' ? <MoonOutlined /> : <SunOutlined />}
      onClick={() => setMobileTheme(mobileTheme === 'light' ? 'dark' : 'light')}
      title={label}
      aria-label={label}
    />
  );
};
